import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("ಸ್ವಾಗತ!");
      navigate("/");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "ಲಾಗಿನ್ ವಿಫಲ");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto py-10">
      <div className="border border-border rounded-sm p-8 bg-card paper-noise">
        <div className="font-ui text-xs uppercase tracking-[0.3em] text-muted-foreground">Login</div>
        <h1 className="font-kannada-heading text-3xl mt-1">ಮತ್ತೆ ಸ್ವಾಗತ</h1>
        <p className="text-sm text-muted-foreground mt-2">ನಿಮ್ಮ ಸುದ್ದಿ ಪ್ರಪಂಚಕ್ಕೆ ಪ್ರವೇಶಿಸಿ.</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="email" className="text-xs uppercase tracking-widest">Email</Label>
            <Input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="rounded-none mt-1"
              data-testid="login-email"
            />
          </div>
          <div>
            <Label htmlFor="password" className="text-xs uppercase tracking-widest">Password</Label>
            <Input
              id="password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="rounded-none mt-1"
              data-testid="login-password"
            />
          </div>
          <Button type="submit" disabled={loading} className="w-full rounded-none" data-testid="login-submit">
            {loading ? "ಪ್ರವೇಶಿಸಲಾಗುತ್ತಿದೆ..." : "ಲಾಗಿನ್"}
          </Button>
        </form>

        <p className="text-sm text-muted-foreground mt-6">
          ಹೊಸಬರೇ?{" "}
          <Link to="/register" className="text-primary font-semibold underline underline-offset-4" data-testid="go-register">
            ನೋಂದಣಿ ಮಾಡಿ
          </Link>
        </p>
      </div>
    </div>
  );
}
